import React, { useState } from "react";
import QuoteNavbar from "../../../Components/Desktop/QuoteNavbar/QuoteNavbar";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Link,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "../../../CommonScss/QuotePage.scss";
import RKTextField from "../../../Components/Common/FieldTypes/RKTextField/RKTextField";
import SelectDropdown from "../../../Components/Common/FieldTypes/SelectDropdown/SelectDropdown";
import DatePicker from "../../../Components/Common/FieldTypes/DatePicker/DatePicker";
import GreyBoxTitle from "../../../Components/Desktop/GreyBoxTitle/GreyBoxTitle";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import CustomButton from "../../../Components/Common/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../../shared/Path";

function ProposarDetails() {
  const navigate = useNavigate();
  const [formFields, setFormFields] = useState<{
    fullName: { value: string; warning: boolean };
    gender: { value: string; warning: boolean };
    ProposerDob: { value: Date | null; warning: boolean };
    motherName: { value: string; warning: boolean };
    mobile: { value: string; warning: boolean };
    email: { value: string; warning: boolean };
    passportNumnber: { value: string; warning: boolean };
    emergencyContactPerson: { value: string; warning: boolean };
    emergencyContact: { value: string; warning: boolean };
    occupation: { value: string; warning: boolean };
    employerName: { value: string; warning: boolean };
    employerAddress: { value: string; warning: boolean };
    taxRegNumber: { value: string; warning: boolean };
    description: { value: string; warning: boolean };
    streetArea: { value: string; warning: boolean };
    pincode: { value: string; warning: boolean };
  }>({
    fullName: { value: "", warning: false },
    gender: { value: "", warning: false },
    ProposerDob: { value: null, warning: false },
    motherName: { value: "", warning: false },
    mobile: { value: "", warning: false },
    email: { value: "", warning: false },
    passportNumnber: { value: "", warning: false },
    emergencyContactPerson: { value: "", warning: false },
    emergencyContact: { value: "", warning: false },
    occupation: { value: "", warning: false },
    employerName: { value: "", warning: false },
    employerAddress: { value: "", warning: false },
    taxRegNumber: { value: "", warning: false },
    description: { value: "", warning: false },
    streetArea: { value: "", warning: false },
    pincode: { value: "", warning: false },
  });

  const gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];
  const occupation_data = [
    { key: "Salaried", value: "Salaried" },
    { key: "Self Employeed", value: "Self Employeed" },
    { key: "Private Employee", value: "Private Employee" },
    { key: "Retired", value: "Retired" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName[3]({
      ...attrName[2],
      [attrName[0]]: { ...[attrName[0]], [attrName[1]]: value },
    });
  };

  const [alignment, setAlignment] = React.useState<string | null>("left");

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    setAlignment(newAlignment);
  };

  return (
    <Box className="quoteWrapper">
      <QuoteNavbar />
      <Grid container spacing={3}>
        <Grid xs maxWidth="300px">
          <div className="ctaBtn mb-4">
            <CustomButton
              class_name="backBtn"
              text_name="Back"
              onClickFunction={() => {
                navigate(-1);
              }}
            />
          </div>
          <Box className="lefSidebar">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <div>
                <p>Travellers:</p>
                <h6>4 Members</h6>
              </div>
              <div>
                <p>Travelling to:</p>
                <h6>England, Canada</h6>
              </div>
              <div>
                <p>Departure on:</p>
                <h6>Dec 6, 2023</h6>
              </div>
              <div>
                <p>Return on:</p>
                <h6>Dec 26, 2023</h6>
              </div>
            </div>
            <Box className="whiteBox">
              <p
                style={{
                  borderBottom: "1px solid #6458D8",
                  marginBottom: "12px",
                }}
              >
                Worldwide Travel Policy
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <h5
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#6458D8",
                  }}
                >
                  ₹ 1,024
                </h5>
                <p>+ Taxes</p>
              </div>
            </Box>
          </Box>
        </Grid>
        <Grid xs>
          <>
            <Grid container spacing={3}>
              <Grid xs={12}>
                <h4 style={{ fontWeight: "500" }}>Proposer's Details</h4>
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Full Name"}
                  value={formFields.fullName.value}
                  attrName={["fullName", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.fullName.warning}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Gender"
                  value={formFields.gender.value}
                  attrName={["gender", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  dropdown_data={gender_data}
                  warn_status={formFields.gender.warning}
                />
              </Grid>
              <Grid xs={4}>
                <DatePicker
                  class_name="inputField datepicker"
                  title={"DOB"}
                  value={formFields.ProposerDob.value}
                  attrName={["ProposerDob", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  error_message=""
                  warn_status={formFields.ProposerDob.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Mother's Maiden Name"}
                  value={formFields.motherName.value}
                  attrName={["motherName", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.motherName.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Mobile"}
                  value={formFields.mobile.value}
                  attrName={["mobile", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.mobile.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Email"}
                  value={formFields.email.value}
                  attrName={["email", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.email.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Passport Number"}
                  value={formFields.passportNumnber.value}
                  attrName={[
                    "passportNumnber",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.passportNumnber.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Emergency Contact Person"}
                  value={formFields.emergencyContactPerson.value}
                  attrName={[
                    "emergencyContactPerson",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.emergencyContactPerson.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Emergency Contact"}
                  value={formFields.emergencyContact.value}
                  attrName={[
                    "emergencyContact",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.emergencyContact.warning}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Occupation"
                  value={formFields.occupation.value}
                  attrName={["occupation", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  dropdown_data={occupation_data}
                  warn_status={formFields.occupation.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Tax Registration No. (TRN)"}
                  value={formFields.taxRegNumber.value}
                  attrName={[
                    "taxRegNumber",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.taxRegNumber.warning}
                />
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Business/Employer Name"}
                  value={formFields.employerName.value}
                  attrName={[
                    "employerName",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.employerName.warning}
                />
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Employer's Address"}
                  value={formFields.employerAddress.value}
                  attrName={[
                    "employerAddress",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.employerAddress.warning}
                />
              </Grid>

              <Grid xs={12}>
                <Box display="flex" gap="12px">
                  <h5
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      marginBottom: "12px",
                      display: "flex",
                      gap: "8px",
                      width: "100%",
                    }}
                  >
                    <GppMaybeIcon />
                    Do you or any member of your immediate family currently hold
                    or previously held a prominent public office?
                  </h5>
                  <ToggleButtonGroup
                    value={alignment}
                    exclusive
                    onChange={handleAlignment}
                    aria-label="text alignment"
                    className="toggleButton"
                  >
                    <ToggleButton value="left" aria-label="left aligned">
                      Yes
                    </ToggleButton>
                    <ToggleButton value="center" aria-label="centered">
                      No
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>
                <p style={{ fontSize: "14px" }}>
                  e.g. head of state/Government member of any house of
                  parliament, Minister of Government, official of any political
                  party, Permanent secretary, Chief technical director or chief
                  officer in charge of ministry, department of government,
                  executive agency or staturtory body, judiciary, military -
                  above rank of captain, police - Assistant commissioner and
                  above, a director of chief ececutive of any company in which
                  the government owns a controlling interest, an individual who
                  holds/held a senior management position in an international
                  organisation.
                </p>
              </Grid>
              <Grid xs={12}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Description"}
                  value={formFields.description.value}
                  attrName={["description", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.description.warning}
                />
              </Grid>
              <Grid xs={12}>
                <GreyBoxTitle title="Correspondence Address" />
              </Grid>
              <Grid xs={12}>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Permanent is same as correspondence address."
                />
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Address Line 1"}
                  value={formFields.employerAddress.value}
                  attrName={[
                    "employerAddress",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.employerAddress.warning}
                />
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Address Line 2"}
                  value={formFields.employerAddress.value}
                  attrName={[
                    "employerAddress",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.employerAddress.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Street/Area"}
                  value={formFields.streetArea.value}
                  attrName={["streetArea", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.streetArea.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Pincode"}
                  value={formFields.pincode.value}
                  attrName={["pincode", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.pincode.warning}
                />
              </Grid>
              <Grid xs={4}>Mohali - Punjab</Grid>
            </Grid>

            {/* Permanent Address */}
            <Grid container spacing={3}>
              <Grid xs={12}>
                <GreyBoxTitle title="Permanent Address" />
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Address Line 1"}
                  value={formFields.employerAddress.value}
                  attrName={[
                    "employerAddress",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.employerAddress.warning}
                />
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Address Line 2"}
                  value={formFields.employerAddress.value}
                  attrName={[
                    "employerAddress",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.employerAddress.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Street/Area"}
                  value={formFields.streetArea.value}
                  attrName={["streetArea", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.streetArea.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Pincode"}
                  value={formFields.pincode.value}
                  attrName={["pincode", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.pincode.warning}
                />
              </Grid>
              <Grid xs={4}>Mohali - Punjab</Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn text-center">
                <CustomButton
                  text_name="Continue"
                  class_name="blueXlBtn"
                  onClickFunction={() => {
                    navigate(PATH.TRAVELLER_DETAILS);
                  }}
                />
              </Grid>
            </Grid>
          </>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ProposarDetails;
